import { http, HttpResponse } from 'msw'

import { getResponseObject } from '@webapp/tests/getResponseObject'
import { TaxApiModelStub } from '../api-models/stubs/TaxApiModel.stub'
import { type TaxApiModel } from '../api-models/TaxApiModel'

export const mockGetTaxSuccess = (
  id: number,
  taxStub: TaxApiModel = TaxApiModelStub.build()
) => {
  return http.get(
    `/api/v3/tax/${id}/`,
    () => {
      return HttpResponse.json(getResponseObject(taxStub), { status: 200 })
    },
    { once: true }
  )
}

export const mockGetTaxError = (id: number) => {
  return http.get(
    `/api/v3/tax/${id}/`,
    () => {
      return new HttpResponse(null, { status: 400 })
    },
    { once: true }
  )
}
